import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

function RequestCard({ msg, onDismiss, onConnect }) {
  const [connecting, setConnecting] = useState(false);

  const handleConnect = async () => {
    setConnecting(true);
    try {
      const { channel_id } = await api.post('/chat/channel', { target_user_id: msg.from_user_id });
      onConnect(channel_id, msg.name);
    } catch {
      setConnecting(false);
    }
  };

  return (
    <div style={{
      background: 'rgba(255,255,255,0.03)',
      border: '0.5px solid rgba(255,255,255,0.08)',
      padding: '18px 20px',
      marginBottom: 12,
    }}>
      <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
        {msg.photo_url ? (
          <img src={msg.photo_url} alt={msg.name} style={{
            width: 52, height: 52, objectFit: 'cover', flexShrink: 0,
            border: '0.5px solid rgba(255,255,255,0.1)',
          }} />
        ) : (
          <div style={{
            width: 52, height: 52, flexShrink: 0,
            background: 'rgba(201,168,76,0.08)',
            border: '0.5px solid rgba(201,168,76,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 20, color: 'var(--gold)',
          }}>
            {(msg.name || '?')[0]}
          </div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 4 }}>
            <span style={{ fontSize: 15, fontWeight: 400, color: 'rgba(255,255,255,0.9)' }}>
              {msg.name}{msg.age ? `, ${msg.age}` : ''}
            </span>
            {msg.location && (
              <span style={{ fontSize: 11, color: 'var(--very-muted)' }}>{msg.location}</span>
            )}
          </div>
          <div style={{
            fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.7)',
            lineHeight: 1.55, fontFamily: 'var(--font-display)', fontStyle: 'italic',
          }}>
            "{msg.message}"
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
        <button
          onClick={handleConnect}
          disabled={connecting}
          style={{
            flex: 1, padding: '10px 0',
            background: 'rgba(201,168,76,0.1)',
            border: '0.5px solid rgba(201,168,76,0.4)',
            color: 'var(--gold)', fontSize: 13, letterSpacing: 0.5,
            cursor: connecting ? 'default' : 'pointer',
          }}
        >
          {connecting ? 'Connecting...' : 'Connect'}
        </button>
        <button
          onClick={() => onDismiss(msg.id)}
          style={{
            padding: '10px 20px',
            background: 'transparent',
            border: '0.5px solid rgba(255,255,255,0.1)',
            color: 'var(--very-muted)', fontSize: 13,
            cursor: 'pointer',
          }}
        >
          Not now
        </button>
      </div>
    </div>
  );
}

export default function Requests() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/pre-match-messages/inbox')
      .then(data => { setMessages(data.messages || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleDismiss = async (id) => {
    setMessages(prev => prev.filter(m => m.id !== id));
    api.post(`/pre-match-messages/${id}/dismiss`).catch(() => {});
  };

  const handleConnect = (channelId, name) => {
    navigate(`/chat/${channelId}`, { state: { name } });
  };

  return (
    <div style={{ minHeight: '100vh', background: '#000', padding: '0 0 40px' }}>
      <div style={{ padding: '20px 20px 0', display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32 }}>
        <button
          onClick={() => navigate('/settings')}
          style={{ background: 'none', border: 'none', color: 'var(--very-muted)', fontSize: 18, cursor: 'pointer', padding: 0 }}
        >
          ←
        </button>
        <div className="display-sm">Message requests</div>
      </div>

      <div style={{ padding: '0 20px' }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 60 }}>
            <span className="spinner" />
          </div>
        ) : messages.length === 0 ? (
          <div style={{ textAlign: 'center', paddingTop: 60, color: 'var(--very-muted)', fontSize: 14 }}>
            No message requests yet.
            <div style={{ marginTop: 8, fontSize: 12 }}>
              When someone with Matchmaker+ reaches out, they'll appear here.
            </div>
          </div>
        ) : (
          messages.map(msg => (
            <RequestCard
              key={msg.id}
              msg={msg}
              onDismiss={handleDismiss}
              onConnect={handleConnect}
            />
          ))
        )}
      </div>
    </div>
  );
}
